module.exports.initGoogleAnalytics = 'initAnalytics'
module.exports.sendContactForm = 'sendContactForm'
